/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { AutogradeJobParams } from './autogradeJobParams';

/**
 * Request model for autograde job
 */
export interface RunAutogradeJobRequest {
  type: 'autograde';
  params: AutogradeJobParams;
  allowOverlappingJobs?: boolean;
}
